import { render, staticRenderFns } from "./treeItem.vue?vue&type=template&id=5ffb795e&scoped=true"
import script from "./treeItem.vue?vue&type=script&lang=js"
export * from "./treeItem.vue?vue&type=script&lang=js"
import style0 from "./treeItem.vue?vue&type=style&index=0&id=5ffb795e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffb795e",
  null
  
)

export default component.exports